import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';
import { Props, Values } from './NumericalSeriesCountersForm.types';
import { useTranslation } from '../../context/translationContext';

/**
 * Form component for editing numerical series counters
 */
export const NumericalSeriesCounterForm = ({ onSubmit, initialValues, onBack }: Props) => {
  const { t } = useTranslation();
  const _initialValues: Values = {
    number: undefined,
  };

  const validationSchema = Yup.object().shape({
    number: Yup.string().required('Number is required.'),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ errors, touched }) => (
        <Form className="w-full">
          <div className="my-4">
            <FormField
              id="number"
              name="number"
              label={t('page.numerical-serie.input-counter-number')}
              type="number"
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="flex float-left">
            <Button title={t('general.back')} color="gray" className="mr-3" onClick={onBack} />
            <Button title={t('general.save')} color="green" type="submit" showLoading />
          </div>
        </Form>
      )}
    </Formik>
  );
};
